import React from "react";

import { Row, Col } from "reactstrap";

// const goToLogin = (e) => {
// 	e.preventDefault();

// 	const returnUrl = window.location.href;

// 	window.location = `/usis/login/?pdurl=${returnUrl}`;
// };

// const LoginLink = ({ isInternalUser, children }) => {
// 	if (isInternalUser) {
// 		return <span>{children}</span>;
// 	}

// 	return (
// 		<a href="/usis/login/?pdurl=/ccpa/index.html" onClick={goToLogin}>
// 			clicking here
// 		</a>
// 	);
// };

//let pdfLink = '';

export default ({ isInternalUser }) => (
	<Row>
		<Col>
			<p>
				The California Privacy Rights Act (CPRA) (sometimes also called the
				California Consumer Privacy Rights Act or CCPA) provides California
				residents the right to make certain requests regarding their personal
				information, subject to various exceptions or whether the relationship
				is within the scope of the CPRA. Review the information below to
				determine if you can make a request to T. Rowe Price based on your
				relationship to us. If you can make a request, please complete the form
				below.
			</p>

			<p>Before submitting this form, please note the following:</p>

			<ul>
				<li>
					Requests will be processed only for current residents of California
					who are eligible to make a CPRA request to T. Rowe Price.
				</li>
			</ul>
			<p>
				If you are an Authorized Agent (or if you are a California resident who
				would like to appoint an Authorized Agent) and would like to make a
				request on someone's behalf, please DO NOT submit the form below.
				Instead,{" "}
				<a
					href="https://www.troweprice.com/content/dam/trowecorp/Pdfs/CCPAPOA112020.pdf"
					target="_blank"
					rel="noopener noreferrer"
				>
					click here
				</a>{" "}
				for Authorized Agent instructions and appropriate forms.
			</p>

			<b>
				Requests to T. Rowe Price are <u>not</u> permitted if:{" "}
			</b>
			<p></p>
			<ul>
				<li>
					You have, had, or applied for a personal T. Rowe Price mutual fund or
					brokerage account or advisory product/service. (If you are a current
					client, you can view your personal and account information through
					your account statements or online at any time.)
				</li>
				<li>
					You have or had a personal or company/entity T. Rowe Price College
					Savings Plan, Maryland 529, or Alaska 529 account or you applied for
					an account. (If you are a current client, you can view your personal
					and account information through account statements or online at any
					time.)
				</li>
				<li>
					You hold T. Rowe Price exchange traded funds (EFTs) or stock of T.
					Rowe Price Group, Inc. in a third-party brokerage or similar account.
					(Please refer to the CPRA notice of the third party with whom you hold
					the account for options available to you.)
				</li>
				<li>
					You are a current, former, or eligible participant in an employer
					retirement plan serviced by T. Rowe Price. (You must make CPRA
					requests to your current or former employer. If you are a current
					participant, you also can view personal and account information
					related to your retirement plan account through account statements or
					at the workplace retirement website at any time.)
				</li>
				<li>
					You have or had a personal or company/entity account with T. Rowe
					Price Charitable (also known as T. Rowe Price Program for Charitable
					Giving) or you applied for an account. (If you are a current client,
					you can view your personal and account information through account
					statements or online at any time.)
				</li>
			</ul>
		</Col>
	</Row>
);
